var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('paginated-browser',{ref:"browserIp",attrs:{"data-callback":_vm.getIp},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.data;
var pagination = ref.pagination;
return [_c('table-ip',{attrs:{"items":data}})]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4007c669","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/BrowseIp.vue
// module id = null
// module chunks = 